import gql from "graphql-tag";
import {client} from "./client";
import {CreateEntityGeometry} from "../../schema/CreateEntityGeometry";
import {FetchResult, Mutation} from "../../types";

const getMutation = (patchObject: {[key: string]: any}): any => ({
    variables: {input: {entitygeometry: patchObject}},
    mutation: gql`${CreateEntityGeometry}`
});

export async function createGeometry (geometryObject: {[key: string]: any}) {
    const result: FetchResult<Mutation> = await client.mutate(getMutation(geometryObject));
    const entityGeometry = result.data?.createEntitygeometry?.entitygeometry;
    if (!entityGeometry) {
        throw new Error('failed to create geom');
    } else {
        await client.cache.reset();
        return entityGeometry;
    }
}

